'use strict';
window.addEventListener('DOMContentLoaded', (e) => {
    let is_white = false;
    //スクロールと連動するheader周り、アニメーション関係の処理===================================================================
    const awsHeader = document.getElementById('js-awsHeader');
    if (awsHeader.classList.contains('awsHeader--nomargin')) {
        is_white = true;
    }
    swiper_exe();
    const bodyTag = document.getElementsByTagName('body')[0];

    let scrolled_point = awsHeader.offsetHeight;
    let switchingHeaderHeight = 0;
    // トップページの場合
    if (document.getElementById('js-indexKv-swiper') != null) {
        switchingHeaderHeight = document.getElementById('js-indexKv-swiper').offsetHeight;
    }
    // シリーズページの場合
    if (document.getElementById('js-seriesDtl__kv') != null) {
        switchingHeaderHeight = document.getElementById('js-seriesDtl__kv').offsetHeight;
    }
    // HOW TO SELECTの場合
    if (document.getElementById('js-howToSelect__kv') != null) {
        switchingHeaderHeight = document.getElementById('js-howToSelect__kv').offsetHeight;
    }
    // Portable Collectionの場合
    if (document.getElementById('js-portable__kv__main') != null) {
        if (window.innerWidth >= 1024) {
            switchingHeaderHeight = document.getElementById('js-portable-pcLeft').offsetHeight;
        } else {
            switchingHeaderHeight = document.getElementById('js-portable__kv__main').offsetHeight;
        }
    }
    // New Arrivals2025の場合（KVの動画を超えるまでロゴやテキストが白）
    if (document.getElementById('js-arr25__kv') != null) {
        switchingHeaderHeight = document.getElementById('js-arr25__kv').offsetHeight;
    }
    // New Arrivals2026の場合（KVの動画やシーンを超えるまでロゴやテキストが白）
    if (document.getElementById('js-na26') != null) {
        if (window.innerWidth >= 1024) {
            const hero = document.getElementById('js-na26Hero');
            if (hero) {
                switchingHeaderHeight = hero.offsetHeight;
            }
        } else {
            const ceilingPendant = document.getElementById('ceiling-pendant');
            if (ceilingPendant) {
                switchingHeaderHeight =
                    ceilingPendant.getBoundingClientRect().top + window.pageYOffset;
            }
        }
    }
    // utility-barがある場合
    let utilityBarHeight = 0;
    if (document.getElementById('js-utility-bar') != null) {
        const utilityBar = document.getElementById('js-utility-bar');
        utilityBarHeight = utilityBar.offsetHeight;
        // utility-barの高さに置き換える
        scrolled_point = utilityBarHeight;
        switchingHeaderHeight = switchingHeaderHeight + utilityBarHeight;
    } else {
        bodyTag.classList.add('js-body-utility-bar-none');
    }
//scroll時の処理
    let ticking = false;
    function getScrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
    }
    function bodyHeader_scroll() {
        const scrollTop = getScrollTop();
        if (scrollTop > scrolled_point) {
            bodyTag.classList.add('js-body-scrolled');
            bodyTag.classList.add('js-body-scrolled--toggle');
        } else {
            bodyTag.classList.remove('js-body-scrolled--toggle');
        }
        if (scrollTop > switchingHeaderHeight) {
            awsHeader.classList.add('awsHeader--shadow');
            if (is_white) {
                awsHeader.classList.remove('awsHeader--white');
            }
        } else {
            awsHeader.classList.remove('awsHeader--shadow');
            if (is_white) {
                awsHeader.classList.add('awsHeader--white');
            }
            if (scrollTop === 0) {
                if (document.querySelector('.js-body-scrolled') != null) {
                    bodyTag.classList.add('js-body-scrolled--comeBack');
                }
            }
        }
        ticking = false;
    }
    function scroll_ticking() {
        if (bodyTag.classList.contains('js-scroll-locked')) return;
        if (!ticking) {
            requestAnimationFrame(bodyHeader_scroll);
            ticking = true;
        }
    }
    addEventListener("scroll", scroll_ticking);
    //アコーディオン=======================================================================================================
    const btns_ac = document.querySelectorAll('.js-btn-accordion');
    btns_ac.forEach((btn_ac, index) => {
        btn_ac.addEventListener('click', (e) => {
            btn_ac.classList.toggle('active');
            let el = btn_ac.nextElementSibling;
            el.classList.toggle('active');
            el.style.height = el.scrollHeight + 'px';
            if (el.classList.contains('active')) {
                el.style.height = el.scrollHeight + 'px';
            } else {
                el.style.height = 0;
            }

            e.preventDefault();
        });
    });
    //アコーディオンでactiveな次の要素の高さを初期値設定
    const btns_ac_sidebar = document.querySelectorAll('.sidebar .js-btn-accordion');
    btns_ac_sidebar.forEach((btn_ac, index) => {
        let el = btn_ac.nextElementSibling;
        if (el.classList.contains('active')) {
            el.style.height = el.scrollHeight + 'px';
        } else {
            el.style.height = 0;
        }
    });

    //swiper(汎用)=======================================================================================================
    function swiper_exe() {
        const w = window.innerWidth;
        let els = document.querySelectorAll('.js-c-swiper');
        // console.log(els);
        let btn_prev = '.js-c-swiper__btn--prev';
        let btn_next = '.js-c-swiper__btn--next';
        let pagination = '.js-c-swiper__pagination';
        let scrollbar = '.js-c-swiper__scrollbar';


        //オプションの取得
        for (let el of els) {
            //console.log(el)
            let slidesPerGroup_pcWide = 1;
            if (el.getAttribute('data-per-group-pc-wide') !== null) {
                slidesPerGroup_pcWide = Number(el.getAttribute('data-per-group-pc-wide'));
            }
            let allowTouchMove_pcWide = true;
            if (el.getAttribute('data-allow-touch-move-pc-wide') !== null) {
                allowTouchMove_pcWide = el.getAttribute('data-allow-touch-move-pc-wide') === 'true';
            }
            // console.log(allowTouchMove_pcWide);
            let options = {};
            options.navigation = {
                nextEl: btn_next,
                prevEl: btn_prev
            };
            options.pagination = {
                el: pagination,
                clickable: true
            };
            options.scrollbar = {
                el: scrollbar,
                hide: false,
                draggable: true
            };
            options.freeMode = {
                enabled: true,
            };
            options.mousewheel = {
                forceToAxis: true,
                sensitivity: 3
            };
            options.breakpoints = {
                0: {
                    slidesPerView: Number(el.getAttribute('data-slides-sp')),
                    spaceBetween: Number(el.getAttribute('data-gutter-sp'))
                },
                750: {
                    slidesPerView: Number(el.getAttribute('data-slides-pc')),
                    spaceBetween: Number(el.getAttribute('data-gutter-pc'))
                },
                1200: {
                    slidesPerView: Number(el.getAttribute('data-slides-pc-wide')),
                    spaceBetween: Number(el.getAttribute('data-gutter-pc-wide')),
                    slidesPerGroup: slidesPerGroup_pcWide,
                    allowTouchMove: allowTouchMove_pcWide
                }
            };
            //console.log('Swiper option',options)
            if (el.getAttribute('data-sp') === 'true' && el.getAttribute('data-pc') === 'true' && el.getAttribute('data-pc-wide') === 'true') {
                let slider = new Swiper(el, options);
            }
            if (el.getAttribute('data-sp') === 'true' && el.getAttribute('data-pc') === 'false' && el.getAttribute('data-pc-wide') === 'false' && w < 750) {
                let slider = new Swiper(el, options);
            }
            if (el.getAttribute('data-sp') === 'true' && el.getAttribute('data-pc') === 'true' && el.getAttribute('data-pc-wide') === 'false' && w < 1024) {
                let slider = new Swiper(el, options);
            }
            if (el.getAttribute('data-sp') === 'false' && el.getAttribute('data-pc') === 'false' && el.getAttribute('data-pc-wide') === 'true' && w >= 1200) {
                let slider = new Swiper(el, options);
            }
            if (el.getAttribute('data-sp') === 'false' && el.getAttribute('data-pc') === 'true' && el.getAttribute('data-pc-wide') === 'false' && w >= 750) {
                let slider = new Swiper(el, options);
            }
        }
    }
    //ハンバーガーメニュー==================================================================================================
    const humMenuBtn = document.getElementById('js-awsHeader__hum');
    const humMenuCnt = document.getElementById('js-awsHeader__menu');

    const headerFeatureSwiperEl = document.getElementById(
        'js-awsHeader__menu__feature__swp'
    );

    let headerFeatureSwiper = null;

    if (headerFeatureSwiperEl && window.innerWidth < 1024) {
        headerFeatureSwiper = new Swiper(headerFeatureSwiperEl, {
            slidesPerView: 2.13,
            spaceBetween: 12,
            freeMode: {
                enabled: true,
                momentum: true
            },
            watchOverflow: true,
            breakpoints: {
                750: {
                    slidesPerView: 3.3,
                    spaceBetween: 20
                }
            }
        });
    }

    humMenuBtn.addEventListener('click', () => {
        humMenuBtn.classList.toggle('js-awsHeader__hum');
        humMenuCnt.classList.toggle('active');
        bodyTag.classList.toggle('js-body-humShow');

        if (
            humMenuCnt.classList.contains('active') &&
            headerFeatureSwiper
        ) {
            requestAnimationFrame(() => {
                headerFeatureSwiper.update();
            });
        }
    });

    //汎用accordion======================================================================================================
    const uniAccordionAll = document.querySelectorAll('.js-c-uniAccordionBtn');
    uniAccordionAll.forEach(uniAccordion => {
        uniAccordion.addEventListener('click', function() {
            uniAccordion.classList.toggle('js-open');
            const uniAccordion_next = this.nextElementSibling;
            if (uniAccordion_next.style.maxHeight && uniAccordion_next.style.maxHeight !== '0px') {
                uniAccordion_next.style.transition = 'max-height 0s ease'; // 閉じるときの速度を設定
                uniAccordion_next.style.maxHeight = '0';
                uniAccordion_next.classList.remove('js-open');
            } else {
                uniAccordion_next.style.transition = 'max-height 0.2s ease'; // 開くときの速度を設定
                uniAccordion_next.style.maxHeight = uniAccordion_next.scrollHeight + 'px';
                uniAccordion_next.classList.add('js-open');
            }
        });
    });
    //複数階層accordion===================================================================================================
    if (document.querySelector(".js-c-acd-btn-1tier") != null) {
        let target_accordion = [];
        if (document.getElementById("js-awsHeader__menu") != null) {
            target_accordion.push(document.getElementById('js-awsHeader__menu'));
        }
        if (document.querySelector(".js-searchModal") != null) {
            target_accordion.push(document.querySelector('.js-searchModal'));
        }
        if (document.querySelector(".js-searchSidebar") != null) {
            target_accordion.push(document.querySelector('.js-searchSidebar'));
        }
        if (document.getElementById("js-product__btm__spec") != null) {
            target_accordion.push(document.getElementById('js-product__btm__spec'));
        }
        for (let accordion of target_accordion) {
            // 1階層
            let acd_1tierBtnAll = accordion.querySelectorAll(".js-c-acd-btn-1tier");
            acd_1tierBtnAll.forEach(function (acd_1tierBtn) {
                acd_1tierBtn.addEventListener("click",function () {
                    acd_1tierBtn.classList.toggle("js-c-acd-btn-1tier--open");
                    acd_1tierBtn.nextElementSibling.classList.toggle("js-c-acd-cnt-1tier--open");
                });
            });
            // 2階層
            let acd_2tierBtnAll = accordion.querySelectorAll(".js-c-acd-btn-2tier");
            acd_2tierBtnAll.forEach(function (acd_2tierBtn,index) {
                index = index + 1;
                //閉じる用ダミーボタン
                let acd_2tierClose = acd_2tierBtn.nextElementSibling;
                //dlリスト
                let acd_2tierCnt = acd_2tierBtn.nextElementSibling.nextElementSibling;
                //各dlにindexで固有のクラスを付与
                let acd_2tierCnt_class = "js-c-acd-cnt-2tier--index" + index;
                acd_2tierCnt.classList.add(acd_2tierCnt_class);
                //※固有のdlの中のdtとddの指定用の文字列を作成（querySelectorAllで使用）
                let acd_2tierBtn_now = '.' + acd_2tierCnt_class + " .js-c-acd-btn-1tier--open";
                let acd_2tierCnt_now = '.' + acd_2tierCnt_class + " .js-c-acd-cnt-1tier--open";
                acdOpenClose();
                //2階層タイトルボタンをタップ時
                acd_2tierBtn.addEventListener("click",function () {
                    acd_2tierBtn.classList.toggle("js-c-acd-btn-2tier--open");
                    acd_2tierCnt.classList.toggle("js-c-acd-cnt-2tier--open");
                    // js-c-acd-btn-1tier--defaultOpenが設置されていれば、デフォルトで開いた状態になる
                    let acd_2tierCntChild = acd_2tierCnt.firstElementChild;
                    if (acd_2tierCntChild.classList.contains("js-c-acd-btn-1tier--defaultOpen")) {
                        acd_2tierCntChild.classList.add("js-c-acd-btn-1tier--open");
                        acd_2tierCntChild.nextElementSibling.classList.add("js-c-acd-cnt-1tier--open");
                    }
                    acd_2tierClose.classList.add("js-c-2tier-acd-close--overlap");
                    acdOpenClose();
                });
                function acdOpenClose() {
                    acd_2tierClose.addEventListener("click",function () {
                        if(accordion.querySelector(acd_2tierBtn_now) != null) {
                            // (.js-c-acd-cnt-2tier--index1 .js-c-acd-btn-1tier--open)というような指定
                            //対象の親のacd_2tierCloseをクリックした時に1階層のアコーディオンが開いていたら
                            let acd_2tierBtn_nowOpenAll = accordion.querySelectorAll(acd_2tierBtn_now);
                            acd_2tierBtn_nowOpenAll.forEach(function (acd_2tierBtn_nowOpen) {
                                //1階層のアコーディオンボタンからクラスをremoveする
                                acd_2tierBtn_nowOpen.classList.remove("js-c-acd-btn-1tier--open");
                            });
                            // (.js-c-acd-cnt-2tier--index1 js-c-acd-cnt-1tier--open)というような指定
                            let acd_2tierCnt_nowOpenAll = accordion.querySelectorAll(acd_2tierCnt_now);
                            acd_2tierCnt_nowOpenAll.forEach(function (acd_2tierCnt_nowOpen) {
                                //1階層のアコーディオンコンテンツからクラスをremoveする
                                acd_2tierCnt_nowOpen.classList.remove("js-c-acd-cnt-1tier--open");
                            });
                        }
                        acd_2tierBtn.classList.remove("js-c-acd-btn-2tier--open");
                        acd_2tierCnt.classList.remove("js-c-acd-cnt-2tier--open");
                        acd_2tierClose.classList.remove("js-c-2tier-acd-close--overlap");
                    });
                }
            });
        }
    }
    //PCのhoverで開くMenu================================================================================================
    const pcMenu = document.querySelectorAll('.js-awsHeader__pc__menu');
    const pcMenuProduct = document.getElementById("js-awsHeader__pc__menu__cnt--product");
    const pcMenuProductClose = document.getElementById("js-awsHeader__pc__menu__cnt__in__sticky__close");
    // イベントを付加
    for (let i = 0; i < pcMenu.length; i++) {
        pcMenu[i].addEventListener('mouseover', hoverOpen);
        pcMenu[i].addEventListener('mouseleave', hoverClose);
    }
    pcMenuProductClose.addEventListener('click', () => {
        bodyTag.classList.remove('js-body-pcMenuOpen');
        pcMenuProduct.classList.remove('is-active');
    });
    // PC hoverで開くMenu
    function hoverOpen(e) {
        // 子メニューa要素
        const pcHoverCnt = e.currentTarget.querySelectorAll('.js-awsHeader__pc__menu__cnt');
        bodyTag.classList.add('js-body-pcMenuOpen');
        // is-activeを付加
        for (let i = 0; i < pcHoverCnt.length; i++) {
            pcHoverCnt[i].classList.add('is-active');
        }
    }
    // PCのhoverOutで閉じるMenu
    function hoverClose(e) {
        // 子メニューリンク
        const pcHoverCnt = e.currentTarget.querySelectorAll('.awsHeader__pc__menu__cnt');
        bodyTag.classList.remove('js-body-pcMenuOpen');
        // is-activeを削除
        for (let i = 0; i < pcHoverCnt.length; i++) {
            pcHoverCnt[i].classList.remove('is-active');
        }
    }
    //PCのheaderの検索ボタン===============================================================================================
    const headerSearch = document.getElementById("js-headerSearch");
    const headerSearchBtn = document.getElementById("js-awsHeader__icon__in__blk--search");
    headerSearchBtn.addEventListener('click', () => {
        commonFadeIn(headerSearch,200);

        let headerSearchCloseAll = document.querySelectorAll(".js-headerSearch-close");
        headerSearchCloseAll.forEach((headerSearchClose) => {
            headerSearchClose.addEventListener('click', () => {
                commonFadeOut(headerSearch, 100);
            });
        });
    });
    const searchInput = document.querySelector('.js-headerSearch__modal__inner__form__kw');
    if (searchInput && searchInput.value !== '') {
        searchInput.value = '';
    }
    //c-product-cardのカラーチップクリック時=================================================================================
    if (document.querySelector(".js-c-btn-colorChip") != null) {
        const btn_colorchips = document.querySelectorAll('.js-c-btn-colorChip');
        btn_colorchips.forEach((el) => {
            el.addEventListener('click', (e) => {
                let img_url = el.getAttribute('data-image');
                let product_url = el.getAttribute('data-url');
                let variant_price_formatted = el.getAttribute('data-price-formatted');

                // 最も近い親要素を取得
                const productCard = el.closest('.c-product-card');
                if (productCard) {
                    let el_target_link = productCard.querySelector('.c-product-card__link');
                    let el_target_imgs = productCard.querySelectorAll('.js-product-card-image');
                    let el_target_price = productCard.querySelector('.js-product-price');

                    // Always update the link
                    if (el_target_link) {
                        el_target_link.setAttribute('href', product_url);
                    }
                    // Update all images
                    el_target_imgs.forEach((img) => {
                        img.setAttribute('src', img_url);
                        img.setAttribute('data-src', img_url);
                    });
                    // Only update the price if data-price-formatted is present
                    // シリーズページなどhtmlのベタの場合は、data-price-formatted属性がないためdata-price-formatted属性があるliquid内だけの処理。
                    // カラーのバリエーション別に価格が異なる場合に、それぞれの価格を表示する。
                    // URL（ハンドル）にハイフンが2つ以上含まれており、かつバリエーション別に価格が異なる場合は、価格に〜をつける（Glow、Phantomなど）
                    if (variant_price_formatted && el_target_price) {
                        let product_handle = productCard.getAttribute('data-handle') || '';
                        let price_different = productCard.getAttribute('data-price-different') === 'true';

                        // Check if the handle contains more than one hyphen
                        let hyphen_count = (product_handle.match(/-/g) || []).length;

                        if (hyphen_count > 1 && price_different) {
                            el_target_price.innerHTML = variant_price_formatted + '〜<small>（税込）</small>';
                        } else {
                            el_target_price.innerHTML = variant_price_formatted + '<small>（税込）</small>';
                        }
                    }
                }
                e.preventDefault();
            });
        });
    }
    //矢印を画像の縦位置中心に表示===========================================================================================
    function set_swiper_arrow_center() {
        let els = document.querySelectorAll('.js-c-swiper');
        for (let el of els) {
            try {
                let target_image = el.querySelector('.swiper-wrapper .swiper-slide img');
                let pos_image = target_image.clientHeight;
                // console.log(pos_image,target_image);
                // console.log("test");
                let target_arrow_prev = el.querySelector('.js-c-swiper__btn--prev');
                let target_arrow_next = el.querySelector('.js-c-swiper__btn--next');
                let pos_arrow = pos_image / 2;
                if (pos_arrow !== 0) {
                    target_arrow_prev.style.top = pos_arrow + 'px';
                    target_arrow_next.style.top = pos_arrow + 'px';
                }
            } catch {
            }
        }
    }
    window.addEventListener('load', (e) => {
        //並び替えが実行されたら商品リスト部分から表示
        let search = location.search;
        if (search.indexOf('?sort_by=') >= 0) {
            let position_products = document.querySelector('#SortBy').getBoundingClientRect().top - 80;
            scrollTo(0, position_products);
        }
        set_swiper_arrow_center();
    });

    //モーダルmodal=======================================================================================================
    // let modalCntHeight = window.innerHeight - 40;
    let body = document.querySelector("body");
    let modalCloseBack = document.getElementById("js-c-modalClose");
    let modalCloseCross = document.getElementById("js-c-modalClose__cross");

    // 商品ページの場合は、アプリが遅れて要素を出力するためsetTimeoutを設置
    if (document.querySelector(".template-product") != null) {
        setTimeout(function () { modalOpenClose(); }, 600);
        setTimeout(function () { modalOpenClose(); }, 1000);
        setTimeout(function () { modalOpenClose(); }, 2000);
        setTimeout(function () { modalOpenClose(); }, 4000);
        setTimeout(function () { modalOpenClose(); }, 8000);
        setTimeout(function () { modalOpenClose(); }, 12000);
        setTimeout(function () { modalOpenClose(); }, 16000);
    } else {
        modalOpenClose();
    }

    function modalOpenClose() {
        if (document.querySelector(".js-c-modalOpen") == null) return;

        let modalOpenAll = Array.prototype.slice.call(document.querySelectorAll(".js-c-modalOpen"));

        modalOpenAll.forEach(function (modalOpen) {
            // ✅ 多重バインド防止（setTimeoutで複数回呼ばれても1回だけbind）
            if (modalOpen.dataset.modalBound === "1") return;
            modalOpen.dataset.modalBound = "1";

            modalOpen.addEventListener("click", function (e) {
                e.preventDefault();

                let modalOpenData = modalOpen.dataset.modal;
                let modalCntAll = Array.prototype.slice.call(document.querySelectorAll(".js-c-modalCnt"));

                modalCntAll.forEach(function (modalCnt) {
                    let modalCntData = modalCnt.dataset.modal;
                    if (modalOpenData !== modalCntData) return;

                    // モーダルを最前面へ
                    body.insertBefore(modalCnt, body.lastElementChild);

                    // close cross/back をモーダルへ移動
                    if (!modalCnt.classList.contains("js-c-modalCnt--closeBtn-out")) {
                        modalCnt.firstElementChild.insertBefore(
                            modalCloseCross,
                            modalCnt.firstElementChild.firstElementChild
                        );
                    }
                    modalCnt.appendChild(modalCloseBack);

                    // 表示
                    commonFadeIn(modalCloseBack, 400);
                    commonFadeIn(modalCnt, 400);
                    modalCnt.classList.add("js-c-modalCnt--open");
                    __enableScrollTrap(".js-c-modalCnt--open .c-modalCnt__in");

                    // =====================================================================
                    // ✅ YouTube（Safari安定化）
                    // - 「open中のDOMをdocument.querySelectorで拾う」方式をやめて、
                    //   “今開いてる modalCnt 内” からiframeを取る
                    // - src null/"" 両対応
                    // - 初回不発対策で iframe を clone して差し替えてから src を入れる
                    // =====================================================================
                    const ytEl = modalCnt.querySelector(".js-c-modalCnt__yt");
                    if (ytEl) {
                        const url = ytEl.dataset.src || ytEl.dataset.copy || "";

                        // Safari対策：iframeを作り直して差し替え
                        const fresh = ytEl.cloneNode(true);
                        fresh.removeAttribute("src");
                        if (url) fresh.setAttribute("src", url);
                        ytEl.parentNode.replaceChild(fresh, ytEl);

                        // YouTube用 close（汎用closeと二重に走らないように stopPropagation）
                        const closeYoutubeAndModal = function (ev) {
                            if (ev) ev.stopPropagation();

                            const ytNow = modalCnt.querySelector(".js-c-modalCnt__yt");
                            if (ytNow) ytNow.removeAttribute("src"); // ""よりSafariで安定

                            commonFadeOut(modalCnt, 0);
                            commonFadeOut(modalCloseBack, 0);
                            modalCnt.classList.remove("js-c-modalCnt--open");
                            unlockScroll();
                        };

                        // ✅ closeは毎回増殖させない（once:true）
                        modalCloseBack.addEventListener("click", closeYoutubeAndModal, { once: true });
                        modalCloseCross.addEventListener("click", closeYoutubeAndModal, { once: true });
                    }

                    // =====================================================================
                    // ✅ 汎用 close（YouTubeモーダルの場合はここでは閉じない）
                    // ※ YouTubeは上の closeYoutubeAndModal が担当（stopPropagation付き）
                    // =====================================================================
                    const closeNormalModal = function (ev) {
                        // YouTube iframeがあるモーダルは専用closeが担当
                        if (modalCnt.querySelector(".js-c-modalCnt__yt")) return;

                        commonFadeOut(modalCnt, 0);
                        commonFadeOut(modalCloseBack, 0);
                        modalCnt.classList.remove("js-c-modalCnt--open");
                        unlockScroll();
                    };

                    modalCloseBack.addEventListener("click", closeNormalModal, { once: true });
                    modalCloseCross.addEventListener("click", closeNormalModal, { once: true });

                    // モーダル内の閉じるボタン
                    const modalCloseBtn = modalCnt.querySelector(".js-c-modalCloseBtn");
                    if (modalCloseBtn) {
                        modalCloseBtn.addEventListener(
                            "click",
                            function () {
                                commonFadeOut(modalCnt, 0);
                                commonFadeOut(modalCloseBack, 0);
                                modalCnt.classList.remove("js-c-modalCnt--open");
                                unlockScroll();
                            },
                            { once: true }
                        );
                    }
                });
            });
        });
    }

});
// フェードイン関数========================================================================================================
function commonFadeIn(node, duration) {
    if (node.style.display === 'none') {
        node.style.display = '';
    } else {
        node.style.display = 'block';
    }
    node.style.opacity = 0;
    let start = performance.now();
    requestAnimationFrame(function tick(timestamp) {
        let easing = (timestamp - start) / duration;
        node.style.opacity = Math.min(easing, 1);
        if (easing < 1) {
            requestAnimationFrame(tick);
        } else {
            node.style.opacity = '';
        }
    });
}
// フェードアウト関数======================================================================================================
function commonFadeOut(node, duration) {
    node.style.opacity = 1;
    let start = performance.now();
    requestAnimationFrame(function tick(timestamp) {
        let easing = (timestamp - start) / duration;
        node.style.opacity = Math.max(1 - easing, 0);
        if (easing < 1) {
            requestAnimationFrame(tick);
        } else {
            node.style.opacity = '';
            node.style.display = 'none';
        }
    });
}
// 背景スクロール抑止（bodyはfixedにしない）
(function () {
    let locked = false;
    let cleanup = null;

    function canScroll(el, dy) {
        if (!el) return false;
        if (el.scrollHeight <= el.clientHeight) return false;
        if (dy < 0 && el.scrollTop > 0) return true; // 上へ
        if (dy > 0 && el.scrollTop + el.clientHeight < el.scrollHeight) return true; // 下へ
        return false;
    }

    function enableScrollTrap(scrollAreaSelector = '.c-modalCnt__in') {
        if (locked) return;
        const selector = scrollAreaSelector;

        // 追記
        document.body.classList.add('js-scroll-locked');

        const onTouchStart = (e) => {
            onTouchMove.__lastY = e.touches[0].clientY;
        };

        const onTouchMove = (e) => {
            const area = e.target.closest(selector);
            const lastY = onTouchMove.__lastY;
            const y = e.touches[0].clientY;
            const dy = lastY == null ? 0 : (y - lastY) * -1; // 下へ移動を正に
            onTouchMove.__lastY = y;
            if (area && canScroll(area, dy)) return;
            e.preventDefault();
        };

        const onWheel = (e) => {
            const area = e.target.closest(selector);
            if (area && canScroll(area, e.deltaY)) return;
            e.preventDefault();
        };

        const onKeyDown = (e) => {
            // 背景スクロール系キーをブロック（モーダル内のスクロールは許可）
            const keys = ['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' ','Spacebar'];
            if (!keys.includes(e.key)) return;
            const active = document.activeElement;
            if (active && active.closest && active.closest(selector)) return;
            e.preventDefault();
        };

        window.addEventListener('touchstart', onTouchStart, { passive: false, capture: true });
        window.addEventListener('touchmove',  onTouchMove,  { passive: false, capture: true });
        window.addEventListener('wheel',      onWheel,      { passive: false, capture: true });
        window.addEventListener('keydown',    onKeyDown,    { capture: true });

        locked = true;
        cleanup = () => {
            window.removeEventListener('touchstart', onTouchStart, { capture: true });
            window.removeEventListener('touchmove',  onTouchMove,  { capture: true });
            window.removeEventListener('wheel',      onWheel,      { capture: true });
            window.removeEventListener('keydown',    onKeyDown,    { capture: true });
            // 追記
            document.body.classList.remove('js-scroll-locked');

            locked = false;
            cleanup = null;
            onTouchMove.__lastY = null;
        };
    }

    function disableScrollTrap() {
        if (cleanup) cleanup();
    }

    // 他ファイルから呼べるように公開
    window.unlockScroll = disableScrollTrap;
    window.__enableScrollTrap = enableScrollTrap;
})();
/*! lazysizes - v5.3.2 */
!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",fastLoadedClass:"ls-is-cached",iframeLoadMode:0,srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,i=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,o=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],a={},G=Array.prototype.forEach,J=function(e,t){if(!a[t]){a[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return a[t].test(e[$]("class")||"")&&a[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var a;if(a=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(a," "))}},V=function(t,a,e){var i=e?P:"removeEventListener";if(e){V(t,a)}r.forEach(function(e){t[i](e,a)})},X=function(e,t,a,i,r){var n=D.createEvent("Event");if(!a){a={}}a.instance=k;n.initEvent(t,!i,!r);n.detail=a;e.dispatchEvent(n);return n},Y=function(e,t){var a;if(!i&&(a=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}a({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,a){a=a||e.offsetWidth;while(a<H.minSize&&t&&!e._lazysizesWidth){a=t.offsetWidth;t=t.parentNode}return a},ee=function(){var a,i;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;a=true;i=false;while(e.length){e.shift()()}a=false};var e=function(e,t){if(a&&!t){e.apply(this,arguments)}else{n.push(e);if(!i){i=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(a,e){return e?function(){ee(a)}:function(){var e=this;var t=arguments;ee(function(){a.apply(e,t)})}},ae=function(e){var a;var i=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){a=false;i=f.now();e()};var s=o&&n>49?function(){o(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(a){return}a=true;t=r-(f.now()-i);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ie=function(e){var t,a;var i=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-a;if(e<i){I(n,i-e)}else{(o||r)(r)}};return function(){a=f.now();if(!t){t=I(n,i)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var M=0;var N=-1;var L=function(e){M--;if(!e||M<0||!e.target){M=0}};var x=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var W=function(e,t){var a;var i=e;var r=x(e);g-=t;b+=t;p-=t;C+=t;while(r&&(i=i.offsetParent)&&i!=D.body&&i!=O){r=(Z(i,"opacity")||1)>0;if(r&&Z(i,"overflow")!="visible"){a=i.getBoundingClientRect();r=C>a.left&&p<a.right&&b>a.top-1&&g<a.bottom+1}}return r};var t=function(){var e,t,a,i,r,n,s,o,l,u,f,c;var d=k.elements;if((h=H.loadMode)&&M<8&&(e=d.length)){t=0;N++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(o=d[t][$]("data-expand"))||!(n=o*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&M<1&&N>2&&h>2&&!D.hidden){w=f;N=0}else if(h>1&&N>1&&M<6){w=u}else{w=_}}if(l!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;l=n}a=d[t].getBoundingClientRect();if((b=a.bottom)>=s&&(g=a.top)<=z&&(C=a.right)>=s*c&&(p=a.left)<=y&&(b||C||p||g)&&(H.loadHidden||x(d[t]))&&(m&&M<3&&!o&&(h<3||N<4)||W(d[t],n))){R(d[t]);r=true;if(M>9){break}}else if(!r&&m&&!i&&M<4&&N<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!o&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){i=v[0]||d[t]}}if(i&&!r){R(i)}}};var a=ae(t);var S=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}L(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,B);X(t,"lazyloaded")};var i=te(S);var B=function(e){i({target:e.target})};var T=function(e,t){var a=e.getAttribute("data-load-mode")||H.iframeLoadMode;if(a==0){e.contentWindow.location.replace(t)}else if(a==1){e.src=t}};var F=function(e){var t;var a=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(a){e.setAttribute("srcset",a)}};var s=te(function(t,e,a,i,r){var n,s,o,l,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(i){if(a){K(t,H.autosizesClass)}else{t.setAttribute("sizes",i)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){o=t.parentNode;l=o&&j.test(o.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||l);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(L,2500);V(t,B,true)}if(l){G.call(o.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!l){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||l)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,H.fastLoadedClass)}S(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){M--}},true)});var R=function(e){if(e._lazyRace){return}var t;var a=n.test(e.nodeName);var i=a&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=i=="auto";if((r||!m)&&a&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;M++;s(e,t,r,i,a)};var r=ie(function(){H.loadMode=3;a()});var o=function(){if(H.loadMode==3){H.loadMode=2}r()};var l=function(){if(m){return}if(f.now()-e<999){I(l,999);return}m=true;H.loadMode=3;a();q("scroll",o,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",a,true);q("resize",a,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(a).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",a,true);O[P]("DOMAttrModified",a,true);setInterval(a,999)}q("hashchange",a,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,a,true)});if(/d$|^c/.test(D.readyState)){l()}else{q("load",l);D[P]("DOMContentLoaded",a);I(l,2e4)}if(k.elements.length){t();ee._lsFlush()}else{a()}},checkElems:a,unveil:R,_aLSL:o}}(),re=function(){var a;var n=te(function(e,t,a,i){var r,n,s;e._lazysizesWidth=i;i+="px";e.setAttribute("sizes",i);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",i)}}if(!a.detail.dataAttr){Y(e,a.detail)}});var i=function(e,t,a){var i;var r=e.parentNode;if(r){a=s(e,r,a);i=X(e,"lazybeforesizes",{width:a,dataAttr:!!t});if(!i.defaultPrevented){a=i.detail.width;if(a&&a!==e._lazysizesWidth){n(e,r,i,a)}}}};var e=function(){var e;var t=a.length;if(t){e=0;for(;e<t;e++){i(a[e])}}};var t=ie(e);return{_:function(){a=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:i}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});